import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'

import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'
import { BASE_URL2 } from 'config/axios'


import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'
import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'
import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'
import { ReactComponent as Zar4lu } from '../../../../../assets/zarahome/4luzara.svg'
import {ReactComponent as Housedecouttenopillow} from '../../../../../assets/zarahome/housedecouttenopillow.svg'
import {ReactComponent as Housedecouttenopillowkids} from '../../../../../assets/zarahome/housedecouttenopillowkids.svg'
import { ReactComponent as Pack2 } from '../../../../../assets/zarahome/pack2cream.svg'
import { ReactComponent as Pack3 } from '../../../../../assets/zarahome/pack3cream.svg'

import {ReactComponent as AflatSheet2Pillow} from '../../../../../assets/zarahome/aflatsheet2pillow.svg'
import {ReactComponent as AflatSheetOnePillow} from '../../../../../assets/zarahome/aflatsheetonepillow.svg'
import {ReactComponent as AduvetCoverOnePillow} from '../../../../../assets/zarahome/aduvetcoveronepillow.svg'
import {ReactComponent as AduvetCoverTwoPillow} from '../../../../../assets/zarahome/aduvetcovertwopillow.svg'
import {ReactComponent as APillowCaseOnePillow} from '../../../../../assets/zarahome/apillowcaseonepillow.svg'
import {ReactComponent as APillowCaseTwoPillow} from '../../../../../assets/zarahome/apillowcasetwopillow.svg'
import {ReactComponent as APillowCaseTwoPillowRectangle} from '../../../../../assets/zarahome/apillowcasetwopillowrectangle.svg'
import {ReactComponent as AFittedBottomSheetNoPillow} from '../../../../../assets/zarahome/afittedbottomsheetnopillow.svg'
import {ReactComponent as KidsDuvetCoverOnePillow} from '../../../../../assets/zarahome/kduvetcoveronepillow.svg'
import {ReactComponent as KidsFlatSheetOnePillow} from '../../../../../assets/zarahome/kflatsheetonepillow.svg'
import {ReactComponent as KidsBottomSheetNoPillow} from '../../../../../assets/zarahome/kidsfittedbottomsheetnopillow.svg'
import {ReactComponent as KidsPillowCaseOnePillow} from '../../../../../assets/zarahome/kidspillowcaseonepillow.svg'
import {ReactComponent as KidsPillowCaseLongPillow} from '../../../../../assets/zarahome/kidspillowcaselongpillow.svg'
import {ReactComponent as KidsPillowCaseRectangle} from '../../../../../assets/zarahome/kidspillowcaserectangle.svg'
import AutoFitGroupLabel11 from './autofitgrouplabel11'

import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import QRCodeComponent from './qrcodecomponent'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCM from './RenderIndoItemsCM'
import DynamicTextKids from './DynamicTextKids'
import RenderIndoItemsKids from './RenderIndoItemsKıds'

export default function Label11({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  qrcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts,
  processedDescriptions,
  category,
  subCategory,
  x,
  y,

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")
const symbol = sizeData?.symbol


const processedData = processedDescriptions[sizeData?.description] || {
  fullText: "",
  partzero: "",
  parttwo: "",
  partthree: "",
  parttwoandthree: "",
  partzerokids: "",
  parttwoandthreekids: ""
};
console.log("sizeData.cardtypeXX",sizeData)


const sCodeeText = sizeData?.sCode
// Kids ise ve ADULT geçiyorsa KIDS olarak değiştir
const sTypeText = (subCategory === 'KIDS' || category === 'Kids') && sizeData?.cardtypeXX?.includes('ADULT')
  ? sizeData.cardtypeXX.replace('ADULT', 'KIDS')
  : sizeData?.cardtypeXX



  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

 
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "5.550mm", height: "auto" },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  // Optimized function using pre-cached descriptions
  function getProductTextById(id) {
    return processedDescriptions[id]?.fullText || "";
  }
  
  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak





 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  let shape
  
  const isBlackLabel = referance?.backgroundColor === 'B'


  // Kart tipi için şartlı SVG component'i
  const renderCardTypeSvg = (cardType, pillowtypeYY) => {
    switch (cardType) {
      case 'ADULT - FLAT SHEET':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AflatSheet2Pillow width="35.867mm" height="20.017mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AflatSheetOnePillow width="35.867mm" height="20.017mm" />
            </div>
          );
        }
        else if (pillowtypeYY === 'TEK YASTIK' && (subCategory === 'KIDS'|| category === 'Kids')) {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <KidsDuvetCoverOnePillow width="37.591mm" height="19.922mm" />
        </div>
        )
        }
        return null;
  
      case 'ADULT - DUVET COVER':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AduvetCoverTwoPillow width="37.591mm" height="19.922mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AduvetCoverOnePillow width="37.591mm" height="19.922mm" />
            </div>
          );

       
        }
        else if (pillowtypeYY === 'TEK YASTIK' && (subCategory === 'KIDS'|| category === 'Kids')) {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <KidsDuvetCoverOnePillow width="37.591mm" height="19.922mm" />
          </div>
          )
        }
        return null;
  
      case 'ADULT - FITTED BOTTOM SHEET':
        if (subCategory === 'KIDS'|| category === 'Kids') {
          return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <KidsBottomSheetNoPillow width="35.829mm" height="17.923mm" />
        </div>
        );
        }else{
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <AFittedBottomSheetNoPillow width="35.829mm" height="17.923mm" />
            </div>
          );
        }
  
  
      case 'ADULT - PILLOW CASE':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <APillowCaseTwoPillow width="35.867mm" height="20.017mm" />
            </div>
          );
          } else if (pillowtypeYY === 'TEK YASTIK') {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <APillowCaseOnePillow width="35.867mm" height="20.017mm" />
              </div>
            );
          }
          else if (pillowtypeYY === 'KARE YASTIK') {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <APillowCaseTwoPillowRectangle width="35.867mm" height="20.017mm" />
              </div>
            );
          }
          else if (pillowtypeYY === 'ÇİFT YASTIK' && (subCategory === 'KIDS'|| category === 'Kids')) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseLongPillow width="35.867mm" height="20.017mm" />
            </div>
            );
            } else if (pillowtypeYY === 'TEK YASTIK' && (subCategory === 'KIDS'|| category === 'Kids')) {
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <KidsPillowCaseOnePillow width="35.867mm" height="20.017mm" />
              </div>
              );
            }
            else if (pillowtypeYY === 'KARE YASTIK' && (subCategory === 'KIDS'|| category === 'Kids')) {
              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <KidsPillowCaseRectangle width="35.867mm" height="20.017mm"/>
              </div>
              );
            }

        return null;
  
      case 'KIDS - DUVET COVER':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsDuvetCoverOnePillow width="37.591mm" height="19.922mm" />
            </div>
          );
     
  
      case 'KIDS - FLAT SHEET':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsFlatSheetOnePillow width="35.867mm" height="20.017mm" />
            </div>
          );

 
  
      case 'KIDS - FITTED BOTTOM SHEET':

          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsBottomSheetNoPillow width="35.829mm" height="17.923mm" />
            </div>
          );

  
      case 'KIDS - PILLOW CASE':
        if (pillowtypeYY === 'ÇİFT YASTIK') {
          return (
      
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseLongPillow width="35.867mm" height="20.017mm" />
            </div>
          );
        } else if (pillowtypeYY === 'TEK YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <KidsPillowCaseOnePillow width="35.867mm" height="20.017mm" />
          </div>
          );
        }
        else if (pillowtypeYY === 'KARE YASTIK') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <KidsPillowCaseRectangle width="35.867mm" height="20.017mm"/>
            </div>
          );
        }
        return null;
  
      default:
        return null;
    }
  };
  

  return (
    <div>
             <div>
          <div>
 
          <div style={{position:"absolute",bottom:-400,left:260,display:"flex",flexDirection:"row",gap:5,padding:10,backgroundColor:"black",boxSizing:"border-box",whiteSpace:"nowrap",alignItems:"center"}}>
          <span className="zara-regular" style={{fontSize:"17pt",color:"white",fontWeight:"bold",whiteSpace:"nowrap"}}>{sCodeeText}</span>
          <span className="zara-regular" style={{fontSize:"17pt",color:"white",fontWeight:"bold",whiteSpace:"nowrap"}}>-{sTypeText}</span>

          </div>
     


          <div style={{position:"absolute",top:0,left:240}}>

          <div
  style={{
    position: "absolute",
    top:  695, // px             // px
    left:-99.1, // px
    transformOrigin: "center",  // opsiyonel: flip sonrası hizayı korumaya yardımcı olur
  }}
>
  {SelectedComponent && (
    <SelectedComponent.component
      width={SelectedComponent.width}
      height={SelectedComponent.height}
    />
  )}
</div>

   
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
          
          {/* Kart tipi SVG component'i */}
          {sizeData?.cardtypeXX && (
            <div style={{
              position: "absolute",
              top: 125,
              left: 34,
              zIndex: 10
            }}>
              {renderCardTypeSvg(sizeData.cardtypeXX,sizeData.pillowtypeYY)}
            </div>
          
          )}
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",position:"absolute",top:14,left:-111,width:"115mm",color:"#786E66"}}>
          <AutoFitGroupLabel11 processedData={processedData} widthMm={115} reversible={sizeData.reversible} />
                  </div>
          <div
  style={{
    position: "absolute",
    top: "219px",
    width: "115mm",
    left: "-111.5px",
    display: "flex",
    flexDirection: "column", // ✅ düzeltildi
    justifyContent: "center",
    alignItems: "center",

  }}
>
  <span     className="zara-regular"
      style={{ fontSize: "8pt",color:"#786E66" }}>{data.zaraHomeLabel11[0].carddesc}</span>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <span
      className="zara-regular"
      style={{ fontSize: "8pt",color:"#786E66" }}
    >
      {sizeData.cm
        ?.replace(/\s*x\s*/g, "x") // boşluklu x'i düzelt
        .replace(/cm$/i, "cm") // cm'yi özel ele al
       // geri kalanını uppercase yap
     }{" "}
      {/* en sondaki CM'yi tekrar küçük yap */}
    </span>
    <span
      className="zara-regular"
      style={{ fontSize: "8pt", marginLeft: "3.7px",color:"#786E66" }}
    >
    /
    </span>
    <span
      className="zara-regular"
      style={{ fontSize: "8pt", marginLeft: "3.7px",color:"#786E66" }}
    >
      {sizeData.inches?.replace(/\s*x\s*/g, "x")}
    </span>

    
  </div>

  <div style={{marginTop:4.5}}>
  {sizeData.pack==="" && (
    <></>
    )}
{sizeData.pack=="Pack 2" && (
    <Pack2 width="9mm" height="3.479mm"/>
    )}
{sizeData.pack=="Pack 3" && (
  <Pack3 width="9mm" height="3.479mm"/>

    )}
  </div>

               </div>
          </div>
          </div>

          </div>
        </div>
    </div>
  )
}
